import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'ac2001',
    ecrans: ['00-2'],
    params:['id' ]
});